import { cn } from '#/lib/utils';

export const Check = ({ className }: { className?: string }) => {
  return (
    <svg
      className={cn('w-14 h-10', className)}
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="stroke-current"
        d="M1.29102 4.70587L5.26264 8.67749L12.4116 1.52856"
        strokeWidth="1.46334"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
